// extracted by mini-css-extract-plugin
module.exports = {"Selection":"Selection_Selection__YSQ3Y","Selection--labelFirst":"Selection_Selection--labelFirst__pTtWr"};